import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { useState } from "preact/hooks"

import Facet from "./Facet"
import RangeSelector from "./RangeSelector"

export default function ToolbarFacets() {
    const { facets } = useFacets()
    const [ activeFacet, setActiveFacet ] = useState(null);

    const handleFacetChange = (facetId) => {
        setActiveFacet(facetId === activeFacet ? null : facetId)
    }

    return (
        <div class="flex items-center space-x-4">
            <p class="text-nowrap">Filter by</p>
            <div class="ns-filters-list flex flex-wrap space-x-2">
                {facets?.map(facet => {
                    switch (facet.type) {
                        case "terms":
                            return (
                                <Facet 
                                    key={facet.id} 
                                    facet={facet} 
                                    activeFacet={activeFacet}
                                    handleFacetChange={handleFacetChange}
                                />
                            )
                        case "stats":
                            return (
                                <RangeSelector 
                                    key={facet.id} 
                                    facet={facet} 
                                    activeFacet={activeFacet}
                                    handleFacetChange={handleFacetChange}
                                />
                            )
                        default:
                            return null
                    }
                })}
            </div>
        </div>         
    )
}
